import { createRouter, createWebHistory } from "vue-router";
import BaseLayout from "@/components/layout/BaseLayout.vue";
import MainLayout from "@/components/layout/MainLayout.vue";
import BlwBaseLayout from "@/components/layout/BlwBaseLayout.vue";
import HomePage from "@/views/HomePage.vue";
import { useLayoutStore } from "@/stores/layoutStore";
import { useAuthStore } from "@/stores/authStore";
import { useNavigationStore } from "@/stores/navigationStore";
import {
  RequestDetailType,
  RequestType,
  useRequestStore,
} from "@/stores/requestStore";

export const RoutesData = {
  // // routes wide하게 name과 path가 중복되면 안됨!
  Auth: {
    path: "/auth",
    component: BaseLayout,
    children: {
      // Login: {
      //   path: "/auth/login",
      //   name: "Login",
      //   meta: { authRequired: false, navigationIndex: 3 },
      //   component: () => import("@/views/auth/LoginPage.vue"),
      // },
      PasswordFindAuthStep1: {
        path: "/auth/password-find/step-01",
        name: "password-find-step01",
        component: () => import("@/views/auth/PasswordFindStep1Page.vue"),
      },
      PasswordFindAuthStep2: {
        path: "/auth/password-find/step-02",
        name: "password-find-step02",
        component: () => import("@/views/auth/PasswordFindStep2Page.vue"),
      },
      PasswordReset: {
        path: "/auth/password-reset",
        name: "password-reset",
        component: () => import("@/views/auth/PasswordResetPage.vue"),
      },
      SignupTerms: {
        path: "/auth/signup-terms",
        name: "signup-terms",
        meta: { authRequired: false },
        component: () => import("@/views/auth/SignupTermsPage.vue"),
      },
      SignupAuth: {
        path: "/auth/signup-auth",
        name: "signup-auth",
        meta: { authRequired: false },
        component: () => import("@/views/auth/SignupAuthPage.vue"),
      },
      SignupInput: {
        path: "/auth/signup-input",
        name: "signup-input",
        meta: { authRequired: false },
        component: () => import("@/views/auth/SignupInputPage.vue"),
      },
      SnsCallBack: {
        path: "/auth/callback/sns",
        name: "AuthCallbackSns",
        component: () => import("@/views/auth/callback/SnsCallback.vue"),
      },
      SignupSuccess: {
        path: "/auth/signup/success",
        name: "SignupSuccess",
        component: () => import("@/views/auth/SignupSuccessPage.vue"),
      },
    },
  },
  // Logout: {path: '/auth/login', name: 'logout', component: LogoutPage, meta: {authRequired: true}},
  Main: {
    path: "/",
    component: MainLayout,
    children: {
      Login: {
        path: "/auth/login",
        name: "Login",
        meta: { authRequired: false, navigationIndex: 3 },
        component: () => import("@/views/auth/LoginPage.vue"),
      },
      MyPage: {
        path: "/my",
        name: "my",
        meta: {
          authRequired: true,
          navigationIndex: 3,
          screenName: "마이페이지",
        },
        component: () => import("@/views/mypage/MyPage.vue"),
      },
      MyHistory: {
        path: "/my-history",
        name: "my-history",
        meta: {
          authRequired: true,
          navigationIndex: 1,
          screenName: "이용내역",
        },
        component: () => import("@/views/mypage/MyHistoryPage.vue"),
      },
      // CollectionPlaceMap: {
      //   path: "/collection-place/map",
      //   name: "collection-place-map",
      //   meta: { navigationIndex: 2 },
      //   component: () => import("@/views/map/CollectionPlaceMapPage.vue"),
      // },
      Main: {
        path: "/",
        name: "main",
        meta: { navigationIndex: 0 },
        component: () => import("@/views/request/MainPage.vue"),
      },
    },
  },
  My: {
    path: "/my",
    component: BaseLayout,
    children: {
      MyInfo: {
        path: "/my/info",
        name: "my-info",
        meta: { authRequired: true, screenName: "회원정보" },
        component: () => import("@/views/mypage/MyInfoPage.vue"),
      },
    },
  },
  CollectionPlace: {
    path: "/collection-place",
    component: BaseLayout,
    children: {
      CollectionPlaceMap: {
        path: "/collection-place/map",
        name: "collection-place-map",
        meta: { navigationIndex: 2, screenName: "집하장찾기" },
        component: () => import("@/views/map/CollectionPlaceMapPage.vue"),
      },
      CollectionPlaceList: {
        path: "/collection-place/list",
        name: "collection-place-list",
        meta: { screenName: "집하장안내" },
        component: () =>
          import("@/views/collection-place/CollectionPlaceListPage.vue"),
      },
      CollectionPlaceSearch: {
        path: "/collection-place/search",
        name: "집하장찾기",
        meta: { screenName: "집하장검색" },
        component: () => import("@/views/map/CollectionPlaceSearchPage.vue"),
      },
      CollectionPlaceFee: {
        path: "/collection-place/fee",
        name: "collection-place-fee",
        component: () => import("@/views/map/CollectionPlaceFeePage.vue"),
      },
    },
  },
  NotFound: {
    path: "/:pathMatch(.*)*",
    component: () => import("@/views/error/NotFoundPage.vue"),
  },
  BannerDetail: {
    path: "/banner",
    name: "banner-detail",
    component: () => import("@/views/main/BannerDetailPage.vue"),
  },
  Blw: {
    path: "/blw",
    component: BaseLayout,
    children: {
      BlwCswIntro: {
        path: "/blw/csw-intro",
        name: "blw-csw-intro",
        meta: { skipBlwGuard: true },
        component: () => import("@/views/blw/BlwCswIntroPage.vue"),
      },
      BlwSelectAddress: {
        path: "/blw/request01",
        name: "blw-request01",
        meta: { requestDepth: true },
        component: () => import("@/views/blw/BlwSelectAddressPage.vue"),
      },
      BlwSelectDate: {
        path: "/blw/request02",
        name: "blw-request02",
        meta: { requestDepth: true },
        component: () => import("@/views/blw/BlwSelectDatePage.vue"),
      },
      BlwSelectItem: {
        path: "/blw/request03",
        name: "blw-request03",
        meta: { requestDepth: true },
        component: () => import("@/views/blw/BlwSelectItemPage.vue"),
      },
      BlwDisposeUser: {
        path: "/blw/request04",
        name: "blw-request04",
        meta: { requestDepth: true },
        component: () => import("@/views/blw/BlwDisposeUserPage.vue"),
      },
      BlwCheckInfo: {
        path: "/blw/request05",
        name: "blw-request05",
        meta: { requestDepth: true },
        component: () => import("@/views/blw/BlwCheckInfoPage.vue"),
      },
      BlwComplete: {
        path: "/blw/request06",
        name: "blw-request06",
        meta: { requestDepth: true },
        component: () => import("@/views/blw/BlwRequestCompletePage.vue"),
      },
      BlwSearchItem: {
        path: "/blw/search-item",
        name: "blw-search-item",
        component: () => import("@/views/blw/BlwSearchItemPage.vue"),
      },
      BlwSearchAdress: {
        path: "/blw/search-address",
        name: "blw-search-address",
        component: () => import("@/views/blw/BlwSearchAddressPage.vue"),
      },
      BlwPayment: {
        path: "/blw/payment",
        name: "blw-payment",
        component: () => import("@/views/blw/BlwPaymentPage.vue"),
        meta: {
          paymentPage: true,
        },
      },
      AddFeeInfo: {
        path: "/blw/add-fee-info",
        name: "blw-add-fee-info",
        component: () => import("@/views/blw/AddFeeInfoPage.vue"),
      },
      BlwRequestPayment: {
        path: "/blw/request/:requestId/payment/success",
        name: "request-payment",
        component: () => import("@/views/blw/BlwRequestPayment.vue"),
        meta: {
          paymentPage: true,
        },
      },
    },
  },
  // 대생폐 HWM 결제·조회 — SMS 링크/PG 콜백 302로 직접 진입하는 경로라
  // Blw children 밖에 두어 직접접근 차단 가드를 타지 않게 한다.
  BulkyWaste: {
    path: "/bulky-waste",
    component: BaseLayout,
    children: {
      BulkyCardPayment: {
        path: "/bulky-waste/payment",
        name: "bulky-card-payment",
        meta: { paymentPage: true },
        component: () => import("@/views/bulky/BulkyCardPaymentPage.vue"),
      },
      BulkyPaymentResult: {
        // NicePay 인증 후 백엔드 콜백이 302로 랜딩시키는 결과 페이지 (?token=result_token)
        path: "/bulky-waste/payment/result",
        name: "bulky-payment-result",
        component: () => import("@/views/bulky/BulkyPaymentResultPage.vue"),
      },
      BulkyDirectPayment: {
        // 안내 SMS의 카드 직결제 랜딩 (?token=share_token)
        path: "/bulky-waste/payment/direct",
        name: "bulky-direct-payment",
        component: () => import("@/views/bulky/BulkyDirectPaymentPage.vue"),
      },
      BulkyLookup: {
        path: "/bulky-waste/lookup",
        name: "bulky-lookup",
        component: () => import("@/views/bulky/BulkyLookupPage.vue"),
      },
    },
  },
  Request: {
    path: "/request",
    component: BaseLayout,
    children: {
      // Main: {
      //   path: "/request/main",
      //   name: "main",
      //   meta: { authRequired: false },
      //   component: () => import("@/views/ServiceMain.vue"),
      // },
      ConstructDetail: {
        path: "/request/detail/construct",
        name: "request-construct",
        meta: { screenName: "폐기물처리신청" },
        component: () => import("@/views/request/ConstructDetail.vue"),
      },
      BlwDetail: {
        path: "/request/detail/blw",
        name: "request-blw",
        meta: { screenName: "배출신고(직접버림)" },
        component: () => import("@/views/request/BlwDetail.vue"),
      },
      FeeDetail: {
        path: "/request/detail/fee",
        name: "request-fee",
        component: () => import("@/views/request/FeeDetail.vue"),
      },
      AskQuoteDetail: {
        path: "/request/detail/quote",
        name: "request-quote",
        meta: { screenName: "폐업철거견적문의" },
        component: () => import("@/views/request/AskQuoteDetail.vue"),
      },
      AskCollectDetail: {
        path: "/request/detail/collect",
        name: "request-collect",
        meta: { screenName: "폐기물처리문의" },
        component: () => import("@/views/request/AskCollectDetail.vue"),
      },
    },
  },
};

const unpackRoute = (route) => {
  let routerData = {};
  routerData.path = route.path;
  routerData.component = route.component;
  if (route.meta) {
    routerData.meta = route.meta;
  }
  if (!route.children) {
    routerData.name = route.name;
  } else {
    let children = [];
    Object.entries(route.children).forEach(([key, value]) => {
      children.push(unpackRoute(value));
    });
    routerData.children = children;
  }

  return routerData;
};

const validateBlwStep = (toPath) => {
  const requestStore = useRequestStore();
  let step = 1;
  switch (toPath) {
    case RoutesData.Blw.children.BlwSelectAddress.path:
      if (
        requestStore.requestType === RequestType.Blw &&
        requestStore.requestDetailType === RequestDetailType.Dispose
      ) {
        step = 1;
      } else {
        step = 2;
      }
      break;
    case RoutesData.Blw.children.BlwSelectDate.path:
      if (
        requestStore.requestType === RequestType.Blw &&
        requestStore.requestDetailType === RequestDetailType.Dispose
      ) {
        step = 2;
      } else {
        step = 1;
      }
      break;
    case RoutesData.Blw.children.BlwSelectItem.path:
      step = 3;
      break;
    case RoutesData.Blw.children.BlwDisposeUser.path:
      step = 4;
      break;
    case RoutesData.Blw.children.BlwCheckInfo.path:
      if (requestStore.requestType === RequestType.Blw) {
        // 배출신고(HWM)는 배출자 인증(request04)이 추가되어 5단계
        step =
          requestStore.requestDetailType === RequestDetailType.Dispose ? 5 : 4;
      } else {
        step = 5;
      }

      break;
    default:
  }

  requestStore.setStep(step);
};

const router = createRouter({
  // 스크롤 위치 초기화
  scrollBehavior() {
    return { top: 0 };
  },
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: Object.entries(RoutesData).map(([key, value]) => unpackRoute(value)),
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  const navigationStore = useNavigationStore();
  const requestStore = useRequestStore();

  if (
    to.path === RoutesData.Main.children.Login.path &&
    authStore.isLogined()
  ) {
    customGuard(
      "잘못된 접근 입니다. 이미 로그인 되어있습니다.",
      RoutesData.Main.children.Main.path,
    );
    next(RoutesData.Main.children.Main.path);
    return;
  }

  if (to.meta.authRequired === true) {
    if (authStore.access == null) {
      customGuard("로그인이 필요합니다.", RoutesData.Main.children.Login.path);
      next(RoutesData.Main.children.Login.path);
      return;
    }
  } else if (to.meta.authRequired === false) {
    if (authStore.access != null) {
      customGuard(
        "잘못된 접근 입니다. 이미 로그인 되어있습니다.",
        RoutesData.Main.children.Main.path,
      );
      next(RoutesData.Main.children.Main.path);
      return;
    }
  }

  // 회원가입 완료창 뒤로가기
  if (
    from.path === RoutesData.Auth.children.SignupSuccess.path &&
    to.path !== RoutesData.Main.children.Main.path
  ) {
    customGuard("잘못된 접근입니다.", "/");
    next("/");
    return;
  }

  if (
    from.path === RoutesData.Blw.children.BlwComplete.path &&
    !(
      to.path === RoutesData.Main.children.Main.path ||
      to.path === RoutesData.Main.children.MyHistory.path ||
      to.path === RoutesData.Blw.children.AddFeeInfo.path ||
      to.path === RoutesData.BulkyWaste.children.BulkyLookup.path
    )
  ) {
    customGuard("잘못된 접근입니다.", "/");
    next("/");
    return;
  }

  if (
    from.path === RoutesData.Main.children.Main.path &&
    to.path === RoutesData.Auth.children.SignupSuccess.path
  ) {
    customGuard("잘못된 접근입니다.", "/");
    next("/");
    return;
  }

  // 배출신고, 내려드림 등 시나리오에서
  if (to.meta.requestDepth === true) {
    validateBlwStep(to.path);
  }

  // *****************************************************************************
  // 결제 시나리오에서

  if (to.meta.paymentPage === true && from.meta.navigationIndex != null) {
    customGuard("잘못된 접근입니다.", "/");
    next("/");
    return;
  }

  // *****************************************************************************

  if (to.meta.navigationIndex != null) {
    navigationStore.chnageSelectedIndex(to.meta.navigationIndex);
  }

  // url 직접 입력 방지
  const isDirectAccess = !document.referrer; // 이전 페이지 정보가 없으면 직접 입력
  const blwChildRoutes = Object.values(RoutesData.Blw.children).map(
    (route) => route.path,
  );

  if (
    blwChildRoutes.includes(to.path) &&
    from.path !== RoutesData.Main.children.MyHistory.path &&
    to.meta.skipBlwGuard !== true
  ) {
    if (requestStore.requestType == null) {
      if (from.meta.paymentPage === true) {
        next();
        return;
      }

      customGuard("잘못된 접근입니다.", "/");
      next("/");
      return;
    } else {
      next();
      return;
    }
  }
  next();
});

function customGuard(message, path) {
  const layoutStore = useLayoutStore();
  layoutStore.showAlertDialog(message, null, null, () => {
    router.push(path);
  });
}

router.onError((error) => {
  const layoutStore = useLayoutStore();
  if (error.nextRoute) {
    if (error.message) {
      layoutStore.showAlertDialog(error.message, null, null, () => {
        router.push(error.nextRoute);
      });
    } else {
      router.push(error.nextRoute);
    }
  } else {
    layoutStore.showAlertDialog(
      error.message ?? "잘못된 접근입니다.",
      null,
      null,
      () => {
        if (error.callback != null) {
          error.callback();
        }
      },
    );
  }
});

export default router;
